import React from 'react'
import { WebsiteTypographyGroup } from 'src/editor/shared/settings/wrappers/entity-and-website-typography-group/website-typography-group'
import { getWebsiteStylesPrimaryButtonsTypography } from 'src/editor/store/website-settings/website-settings-selector'
import { updateWebsiteStylesPrimaryButtonsTypography } from 'src/editor/store/website-settings/website-settings-actions'
import { WebsiteTypographySettingsStylesInterface } from 'src/editor/store/website-settings/website-settings-types'
import { SettingsNestedMenu } from '../settings/settings-nested-menu'
import { useWebsiteSettings } from 'client/store'

export const WebsiteStylesSettingsButtonsAndLinks = () => {
  const primaryButtonsTypography = useWebsiteSettings(
    getWebsiteStylesPrimaryButtonsTypography,
  ) as WebsiteTypographySettingsStylesInterface

  return (
    <>
      <SettingsNestedMenu menuButtonLabel="Typography" menuTitle="Typography">
        <WebsiteTypographyGroup
          typographyObject={primaryButtonsTypography}
          updateTypographyAction={updateWebsiteStylesPrimaryButtonsTypography}
          hideTitle
          isFirst
        />
      </SettingsNestedMenu>
    </>
  )
}
